<!--
 * @Descripttion: 
 * @version: 
 * @Author: wuxiaoling-ghq
 * @LastEditors: wuxiaoling-ghq
-->
<template>
    <div class="loading">
        <Col class="demo-spin-col" span="8"  v-show="displayShow">
            <Spin fix>
                <figure>
                    <img :src="loadingImg" />
                </figure>
                <div class="info">正在寻宝中，请稍后...</div>
            </Spin>
        </Col>
    </div>
</template>
<script>
/*
<Loading ref="loading"></Loading>
*/
export default {
    name: 'Loading',
    data() {
        return {
            displayShow: false,
            loadingImg:require("../assets/img/loading.gif")
        }
    },
    mounted() {

    },
    methods: {
        show() {
            this.displayShow = true;
        },
        hide() {
            this.displayShow = false;
        }
    }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.loading{
    left: 0;
    top: 0;
    position: fixed;
    z-index: 1;
}
.demo-spin-col {
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: 9999 !important;
    font-size: 18px;
    .demo-spin-icon-load {
        animation: ani-demo-spin 1s linear infinite !important;
    }
    .ivu-icon-ios-loading{
        font-size:36px;
    }
}
figure{
    width:200px;
    height:200px;
    margin: 0 auto;
    img{
        width:100%;
        height:100%;
    }
}
.info{
    font-size:36px;
}
</style>